export default __webpack_public_path__ + "static/media/kurpe-karpit.f7d95aa5.png";